import api from '@/api/role'
import baseModule from '@/store/shared/rest'

const defaultModule = baseModule('ROLES', 'role', api)

export default {
    ...defaultModule,
    namespaced: true,
}
